import React, { useEffect, useState } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useAppDispatch } from 'app/hooks';
import { Spin, Alert } from 'antd';

const QuickbooksCallback: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const handleQuickbooksCallback = async () => {
      try {
        // Get authorization code from URL parameters
        const searchParams = new URLSearchParams(location.search);
        const authCode = searchParams.get('code');
        const state = searchParams.get('state');
        const realmId = searchParams.get('realmId');
        const errorParam = searchParams.get('error');

        if (errorParam) {
          setError('Quickbooks authentication was cancelled or failed.');
          setLoading(false);
          return;
        }

        if (!authCode) {
          setError('Authorization code not found in callback URL.');
          setLoading(false);
          return;
        }

        if (!realmId) {
          setError('realmId parameter not found in callback URL.');
          setLoading(false);
          return;
        }

        // Exchange code for JWT token
        const result = await dispatch.app.loginQuickbooks({
          authCode: authCode!,
          state: state || '',
          realmId: realmId!,
        });
        setLoading(false);

        if (result.success) {
          window.location.pathname = '/workspace';
        }
      } catch (err: any) {
        console.error('SSO callback error:', err);
        setError(err.message || 'An error occurred during SSO authentication.');
        setLoading(false);
      }
    };

    handleQuickbooksCallback();
  }, [location.search, dispatch.app, history]);

  const handleReturnWorkspace = () => {
    window.location.pathname = '/workspace';
  };

  if (loading) {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          padding: '40px 20px',
        }}
      >
        <Spin size="large" />
        <p style={{ marginTop: '16px', textAlign: 'center' }}>
          Completing Quickbooks login...
        </p>
      </div>
    );
  }

  if (error) {
    return (
      <div
        style={{
          maxWidth: '400px',
          margin: '40px auto',
          padding: '20px',
        }}
      >
        <Alert
          message="Quickbooks Login Error"
          description={error}
          type="error"
          showIcon
        />
        <div
          style={{
            marginTop: '16px',
            textAlign: 'center',
          }}
        >
          <button
            onClick={handleReturnWorkspace}
            style={{
              border: 'none',
              background: 'none',
              color: '#1890ff',
              cursor: 'pointer',
              textDecoration: 'underline',
              fontSize: '14px',
            }}
          >
            Return to Workspace
          </button>
        </div>
      </div>
    );
  }

  return null;
};

export default QuickbooksCallback;
